export interface AppConfiguration {
  googleClientId: string;
  microsoftClientId: string;
  iosGoogleClientId: string;
  iosGoogleRedirectURI: string;
  androidGoogleRedirectURI: string;
  nativeRedirectURI: string;
  appleClientId: string;
  appleRedirectURI: string;

  apiUrl: string;
  lanApiUrl: string;
  redirectUri: string;
  mobilePreview: boolean;

  posthogKey?: string;

  googleProjectId: string;
  environment: "production" | "staging" | "development";
}

function buildConfig(): AppConfiguration {
  // OAuth
  const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "";
  const microsoftClientId = process.env.NEXT_PUBLIC_MICROSOFT_CLIENT_ID ?? "";
  const redirectUri = process.env.NEXT_PUBLIC_REDIRECT_URI ?? "";
  const iosGoogleClientId = process.env.NEXT_PUBLIC_IOS_GOOGLE_CLIENT_ID ?? "";
  const iosGoogleRedirectURI =
    process.env.NEXT_PUBLIC_IOS_GOOGLE_REDIRECT_URI ?? "";
  // Android Google OAuth uses the web redirect URI - the callback page
  // will detect the Android platform from state and redirect to custom scheme
  const androidGoogleRedirectURI =
    process.env.NEXT_PUBLIC_ANDROID_GOOGLE_REDIRECT_URI ?? redirectUri;
  const nativeRedirectURI = process.env.NEXT_PUBLIC_NATIVE_REDIRECT_URI ?? "";

  const appleClientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID ?? "";
  const appleRedirectURI = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI ?? "";

  //   if (googleClientId === undefined || redirectUri === undefined) {
  //     throw Error("Google Client config missing");
  //   }

  // Backend url
  const apiUrl = process.env.NEXT_PUBLIC_API_URL ?? "";
  //   if (apiUrl === undefined) {
  //     throw Error("API URL config missing");
  //   }

  // Wifi mobile development mode
  const mobilePreview = process.env.NEXT_PUBLIC_MOBILE_PREVIEW === "true";
  const lanApiUrl = process.env.NEXT_PUBLIC_LAN_API_URL ?? "";

  //   if (mobilePreview && lanApiUrl === "") {
  //     throw Error("To run in mobile preview mode set NEXT_PUBLIC_LAN_API_URL");
  //   }

  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const googleProjectId = process.env.GOOGLE_PROJECT_ID ?? "";

  const environment = (
    process.env.NEXT_PUBLIC_ENVIRONMENT === "production" ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === "staging" ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === "development"
      ? process.env.NEXT_PUBLIC_ENVIRONMENT
      : "development"
  ) as AppConfiguration["environment"];

  return {
    googleClientId,
    microsoftClientId,
    iosGoogleClientId,
    iosGoogleRedirectURI,
    androidGoogleRedirectURI,
    nativeRedirectURI,

    appleClientId,
    appleRedirectURI,

    apiUrl,
    lanApiUrl,
    redirectUri,

    mobilePreview,

    posthogKey,
    googleProjectId,
    environment
  };
}

const appConfig = buildConfig();

export default appConfig;
